<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import BankingImportsWorkspace from '@/views/Banking/Imports/BankingImportsWorkspace.vue'

definePage({
  meta: { ...PageMeta.Banking.Imports.Meta, pageTitle: PageMeta.Banking.Imports.Title },
})
</script>

<template>
  <BankingImportsWorkspace />
</template>
